import { ReactNode } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { useMobile } from '../../../common/services/screenSize/ScreenSizeService';
import { onMobile } from '../../../common/styles/onMobile';
import { prop } from '../../../common/util/prop';
import { propSwitch } from '../../../common/util/propSwitch';
import { OVERLAY_ANIMATION_DURATION } from '../../constants';
import { useOverlay } from './OverlayContext';

export const Drawer = ({ children }: { children?: ReactNode }) => {
  const { y, activeId } = useOverlay();
  const isMobile = useMobile();

  return (
    <CSSTransition
      appear={Boolean(activeId)}
      in={Boolean(activeId)}
      timeout={OVERLAY_ANIMATION_DURATION}
    >
      <Container y={y} isMobile={isMobile}>
        {children}
      </Container>
    </CSSTransition>
  );
};

export const DRAWER_WIDTH = 808;

const Container = styled.div<{ y: number; isMobile: boolean }>`
  background-color: white;
  bottom: 0;
  display: flex;
  margin: 55px 0 0;
  overflow-y: scroll;
  position: absolute;
  right: 0;
  top: ${prop('y')}px;
  width: ${DRAWER_WIDTH}px;

  ${onMobile} {
    width: unset;
    bottom: 0;
    left: 0;
    margin: 0;
    right: 0;
    top: 0;
  }

  &.appear {
    transform: ${propSwitch('isMobile', 'translateY(100%)', 'translateX(' + DRAWER_WIDTH + 'px)')};
  }

  &.appear-active {
    transform: ${propSwitch('isMobile', 'translateY(0)', 'translateX(0)')};
    transition: transform ${OVERLAY_ANIMATION_DURATION}ms;
  }

  &.exit {
    transform: ${propSwitch('isMobile', 'translateY(0)', 'translateX(0)')};
  }

  &.exit-active {
    transform: ${propSwitch('isMobile', 'translateY(100%)', 'translateX(' + DRAWER_WIDTH + 'px)')};
    transition: transform ${OVERLAY_ANIMATION_DURATION}ms;
  }
`;
